/* ============================================================
   KSU Nav — behavior
   Paged mobile drawer (root list -> category sub-pages),
   item accessory strip toggles, desktop hover-intent panels
   + page dim, gallery-mode accessory tabs (click/hover),
   predictive search via /search/suggest.json,
   live cart-count badge (fetch + XHR interception).
   No dependencies. Namespaced under [data-ksu-*].
   ============================================================ */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;

  /* ---------- mobile drawer ---------- */
  var drawer = doc.querySelector('[data-ksu-drawer]');
  var backdrop = doc.querySelector('[data-ksu-drawer-backdrop]');
  var openBtn = doc.querySelector('[data-ksu-drawer-open]');
  var rootPage = drawer ? drawer.querySelector('[data-ksu-page-root]') : null;

  function showPage(page) {
    if (!drawer) return;
    drawer.querySelectorAll('.ksu-drawer__page').forEach(function (p) {
      var current = p === page;
      p.classList.toggle('is-current', current);
      if (!p.hasAttribute('data-ksu-page-root')) {
        p.setAttribute('aria-hidden', String(!current));
      }
    });
  }

  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    if (backdrop) {
      backdrop.hidden = false;
      backdrop.classList.toggle('is-open', open);
    }
    root.classList.toggle('ksu-drawer-lock', open);
    if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
    if (!open) {
      // reset to the root page for next time (after the slide-out finishes)
      setTimeout(function () { if (rootPage) showPage(rootPage); }, 320);
      if (openBtn) openBtn.focus();
    }
  }

  if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
  if (backdrop) backdrop.addEventListener('click', function () { setDrawer(false); });

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-ksu-drawer-close]')) { setDrawer(false); return; }

      var back = e.target.closest('[data-ksu-page-back]');
      if (back) { if (rootPage) showPage(rootPage); return; }

      var opener = e.target.closest('[data-ksu-open-page]');
      if (opener) {
        var id = opener.getAttribute('data-ksu-open-page');
        var page = drawer.querySelector('[data-ksu-page="' + id + '"]');
        if (page) {
          showPage(page);
          var scroll = page.querySelector('.ksu-drawer__scroll');
          if (scroll) scroll.scrollTop = 0;
        }
      }
    });
  }

  /* ---------- item accessory strip toggles (panel + drawer) ---------- */
  doc.addEventListener('click', function (e) {
    var toggle = e.target.closest('.ksu-itemacc__toggle');
    if (!toggle) return;
    var box = toggle.closest('[data-ksu-itemacc]');
    if (!box) return;
    var body = box.querySelector('[data-ksu-itemacc-body]');
    var opening = !box.classList.contains('is-open');
    box.classList.toggle('is-open', opening);
    toggle.setAttribute('aria-expanded', String(opening));
    if (body) body.style.maxHeight = opening ? body.scrollHeight + 'px' : '0px';
  });

  /* ---------- desktop mega panels (hover intent + click + page dim) ---------- */
  var header = doc.querySelector('[data-ksu-header]');
  var deskNav = doc.querySelector('[data-ksu-desktop-nav]');
  var hoverTimer = null;
  var pointerFine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
  var navOverlay = null;

  function ensureNavOverlay() {
    if (navOverlay) return navOverlay;
    navOverlay = doc.createElement('div');
    navOverlay.className = 'ksu-nav-overlay';
    navOverlay.setAttribute('aria-hidden', 'true');
    doc.body.appendChild(navOverlay);
    navOverlay.addEventListener('click', closeAllPanels);
    return navOverlay;
  }

  function closeAllPanels() {
    if (!deskNav) return;
    deskNav.querySelectorAll('.ksu-nav__item.is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var btn = item.querySelector('button.ksu-nav__link');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
    if (navOverlay) navOverlay.classList.remove('is-open');
  }

  function openPanel(item) {
    if (item.classList.contains('is-open')) return;
    closeAllPanels();
    item.classList.add('is-open');
    var btn = item.querySelector('button.ksu-nav__link');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    ensureNavOverlay().classList.add('is-open');
  }

  if (deskNav && header) {
    if (pointerFine) {
      deskNav.addEventListener('mouseover', function (e) {
        var item = e.target.closest('[data-ksu-panel-item]');
        if (!item) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { openPanel(item); }, 60);
      });
      header.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(closeAllPanels, 180);
      });
      header.addEventListener('mouseenter', function () { clearTimeout(hoverTimer); });
    }
    deskNav.addEventListener('click', function (e) {
      var btn = e.target.closest('button.ksu-nav__link');
      if (!btn) return;
      var item = btn.closest('[data-ksu-panel-item]');
      if (!item) return;
      if (item.classList.contains('is-open')) { closeAllPanels(); } else { openPanel(item); }
    });
    doc.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeAllPanels();
    });

    /* gallery mode: accessory strip switches via the tab bar (click or
       hover) and as a shortcut when hovering a tile with accessories */
    function activateAcc(zone, idx) {
      if (!zone) return;
      zone.querySelectorAll('[data-ksu-acc-panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-ksu-acc-panel') === idx);
      });
      zone.querySelectorAll('[data-ksu-acc-tab]').forEach(function (t) {
        var on = t.getAttribute('data-ksu-acc-tab') === idx;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
      });
    }

    deskNav.addEventListener('mouseover', function (e) {
      var tab = e.target.closest('[data-ksu-acc-tab]');
      if (tab) {
        activateAcc(tab.closest('[data-ksu-acczone]'), tab.getAttribute('data-ksu-acc-tab'));
        return;
      }
      var tile = e.target.closest('[data-ksu-acc-src]');
      if (!tile) return;
      var panel = tile.closest('.ksu-panel');
      if (!panel) return;
      activateAcc(panel.querySelector('[data-ksu-acczone]'), tile.getAttribute('data-ksu-acc-src'));
    });

    deskNav.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-ksu-acc-tab]');
      if (!tab) return;
      activateAcc(tab.closest('[data-ksu-acczone]'), tab.getAttribute('data-ksu-acc-tab'));
    });
  }

  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeAllPanels();
    if (drawer && drawer.classList.contains('is-open')) setDrawer(false);
    doc.querySelectorAll('[data-ksu-search-results]').forEach(function (p) { p.hidden = true; });
    if (doc.activeElement && doc.activeElement.matches && doc.activeElement.matches('[data-ksu-search-input]')) {
      doc.activeElement.blur();
    }
  });

  /* ---------- live cart count ---------- */
  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var countTimer = null;

  function setCartCount(n) {
    var icon = doc.querySelector('[data-ksu-cart-icon]');
    if (!icon) return;
    var badge = icon.querySelector('.ksu-header__cart-count');
    if (n > 0) {
      if (!badge) {
        badge = doc.createElement('span');
        badge.className = 'ksu-header__cart-count';
        icon.appendChild(badge);
      }
      badge.textContent = n > 99 ? '99+' : String(n);
      icon.setAttribute('aria-label', 'Cart (' + n + ' items)');
    } else if (badge) {
      badge.remove();
      icon.setAttribute('aria-label', 'Cart (0 items)');
    }
  }

  function refreshCartCount() {
    clearTimeout(countTimer);
    countTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (c && typeof c.item_count === 'number') setCartCount(c.item_count);
        })
        .catch(function () {});
    }, 250);
  }

  // Intercept fetch-based cart mutations (theme cart drawer, apps)
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var arg = arguments[0];
      var url = typeof arg === 'string' ? arg : (arg && arg.url) || '';
      var promise = origFetch.apply(this, arguments);
      if (CART_MUTATION_RE.test(url)) {
        promise.then(function () { refreshCartCount(); }).catch(function () {});
      }
      return promise;
    };
  }

  // Intercept XHR-based cart mutations (jQuery ajax)
  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._ksuCartMutation = CART_MUTATION_RE.test(url || '');
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this._ksuCartMutation) {
        this.addEventListener('loadend', refreshCartCount);
      }
      return origSend.apply(this, arguments);
    };
  }

  // Common custom events some scripts dispatch after cart changes
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build', 'ajaxCart:updated'].forEach(function (ev) {
    doc.addEventListener(ev, refreshCartCount);
  });

  // Sync when returning via back/forward cache
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refreshCartCount();
  });

  /* ---------- predictive search ---------- */
  var suggestUrl = (window.KSU_NAV && window.KSU_NAV.suggestUrl) || '/search/suggest.json';

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  function escapeHtml(s) {
    var d = doc.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function renderResults(container, products, query) {
    if (!products.length) {
      container.innerHTML =
        '<div class="ksu-search__empty">No matches for “' + escapeHtml(query) + '”. ' +
        '<a href="/search?q=' + encodeURIComponent(query) + '">See all results</a></div>';
      return;
    }
    container.innerHTML = products.map(function (p) {
      var img = p.featured_image && p.featured_image.url
        ? '<img src="' + p.featured_image.url + '&width=120" alt="" loading="lazy">'
        : '';
      return '<a class="ksu-search__item" href="' + p.url + '">' +
        '<span class="ksu-search__thumb">' + img + '</span>' +
        '<span class="ksu-search__name">' + escapeHtml(p.title) + '</span>' +
        '</a>';
    }).join('');
  }

  doc.querySelectorAll('[data-ksu-search]').forEach(function (shell) {
    var input = shell.querySelector('[data-ksu-search-input]');
    var pop = shell.querySelector('[data-ksu-search-results]');
    if (!input || !pop) return;

    var controller = null;

    // Opening the header search should dismiss any open mega panel
    if (header && header.contains(shell)) {
      input.addEventListener('focus', function () { closeAllPanels(); });
    }

    var run = debounce(function () {
      var q = input.value.trim();
      if (!q) { pop.hidden = true; pop.innerHTML = ''; return; }
      if (controller) controller.abort();
      controller = new AbortController();

      var url = suggestUrl +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=4' +
        '&resources[options][unavailable_products]=hide';

      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          pop.hidden = false;
          renderResults(pop, products, q);
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') { pop.hidden = true; }
        });
    }, 220);

    input.addEventListener('input', run);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var q = input.value.trim();
        if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
      }
    });
    doc.addEventListener('click', function (e) {
      if (!shell.contains(e.target)) pop.hidden = true;
    });
    input.addEventListener('focus', function () {
      if (input.value.trim() && pop.innerHTML) pop.hidden = false;
    });
  });
})();
